<template>
    <div>
        <div class="row justify-content-between">
            <div class="col-4">
                <p class="theme-search-results-item-flight-section-meta-date text-white">
                    <span>
                        {{ cargo.dateTime }}
                    </span>
                </p>
            </div>
            <div class="col-4 w-auto d-flex justify-content-end">
                <span class="ribbon" v-if="getFormattedDate(cargo.time + '000') <= 60">جدید</span>
                <span v-if="cargo.userType == 'owner' && cargo.isBot == '0'" class="new">فوری</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['cargo'],
    methods: {
        getFormattedDate(dates) {
            var myDate = new Date();
            // var offset = myDate.getTimezoneOffset() * 60 * 1000;
            var withOffset = myDate.getTime();
            // console.log(withOffset);
            // var withoutOffset = withOffset - offset;
            var current = withOffset - dates;
            // console.log(current);
            const minutes = Math.floor(current / 1000 / 60);
            // console.log(minutes);
            return minutes;
        }
    }
}
</script>
<style></style>